angular.module('ui.order.orderItemsGridRouteContainer', [])

    .config(function ($stateProvider) {
        $stateProvider.state('client.orders', {
            url: '/orders?step&search&exact',
            templateUrl: 'app/ui/order/orderItemsGridView/orderItemsGridRouteContainer/orderItemsGridRouteContainer.html',
            data: {pageTitle: 'OrderManager: Orders'},
            controller: 'OrderItemsGridRouteContainerController',
            controllerAs: 'OrderItemsGridRouteContainerController',
            params: {step: 'all-open', search: null, exact: false} // to silently pass parameters to state
        });
    })

    .controller('OrderItemsGridRouteContainerController', function ($scope, $stateParams, orderItemsGridSharedSettings) {

        orderItemsGridSharedSettings.setStepFilter($stateParams.step);
        if ($stateParams.search) {
            orderItemsGridSharedSettings.setTextSearch($stateParams.search, !$stateParams.exact);
        }

    })

;